import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { INSIGHTS } from "@/data/content";

export default function Insights() {
  return (
    <div data-testid="insights-page" className="pt-32 pb-24">
      <Seo
        title="Insights & Perspectives"
        description="Selected field notes, research, and points of view from the AlchamisGroup partnership."
        path="/insights"
      />

      <section className="max-w-[1400px] mx-auto px-6 md:px-12">
        <span className="overline">Insights</span>
        <h1 className="font-display text-5xl sm:text-7xl text-[#001B54] mt-6 leading-[1.02]">
          Selected
          <span className="italic gold-text"> perspectives.</span>
        </h1>
        <p className="text-[#3F4A6B] mt-6 max-w-2xl leading-relaxed">
          Field notes, research, and points of view from the AlchamisGroup partnership.
        </p>
      </section>

      <section className="mt-20 max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {INSIGHTS.map((i, idx) => (
            <Link
              key={i.id}
              to={`/insights/${i.id}`}
              data-testid={`insight-card-${i.id}`}
              className={`group border border-[#001B54]/10 hover:border-gold/40 transition-all duration-500 ${idx === 0 ? "lg:col-span-2 lg:row-span-2" : ""}`}
            >
              <div className={`overflow-hidden ${idx === 0 ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
                <img src={i.image} alt={i.title} className="w-full h-full object-cover opacity-65 group-hover:opacity-95 group-hover:scale-105 transition-all duration-1000" />
              </div>
              <div className="p-8">
                <div className="text-[0.6rem] tracking-[0.28em] uppercase text-gold mb-3">{i.category} · {i.readTime}</div>
                <h2 className={`font-display text-[#001B54] leading-tight ${idx === 0 ? "text-4xl" : "text-2xl"}`}>{i.title}</h2>
                <p className="text-[#3F4A6B] text-sm mt-4 leading-relaxed">{i.summary}</p>
                <div className="mt-6 text-gold text-xs tracking-[0.22em] uppercase">Read perspective →</div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="mt-24 max-w-[1100px] mx-auto px-6 md:px-12 text-center">
        <h2 className="font-display text-4xl text-[#001B54] leading-tight">Receive AlchamisGroup briefings.</h2>
        <p className="text-[#3F4A6B] mt-4">Quarterly memos, by invitation.</p>
        <div className="mt-8 flex justify-center">
          <Link to="/contact" className="luxury-button">Request Invitation</Link>
        </div>
      </section>
    </div>
  );
}
